import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0f0f10] border-t border-[#3a2222] pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div>
            <h3 className="heading-4 text-[#dc2626] mb-4">Dark Tourism Malaysia</h3>
            <p className="body-small text-white/70 mb-4">
              Documenting and preserving Malaysia's dark tourism heritage through research, storytelling, and education.
            </p>
            <p className="caption text-[#888680]">
              "Places remember."
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Explore</h4>
            <ul className="space-y-2">
              <li><Link to="/explore" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">Dark Tourism Destinations</Link></li>
              <li><Link to="/itineraries" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">Itineraries</Link></li>
              <li><Link to="/guidelines" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">Visitor Tips</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Dark Tourism</h4>
            <ul className="space-y-2">
              <li><Link to="/dark-tourism-explained" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">What is Dark Tourism?</Link></li>
              <li><Link to="/dark-tourism-explained#typologies" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">Typologies & Examples</Link></li>
              <li><Link to="/dark-tourism-explained#levels" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">Levels of Darkness</Link></li>
            </ul>
          </div>

          {/* Hidden Stories */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Hidden Stories</h4>
            <ul className="space-y-2">
              <li><Link to="/wall-of-stories" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">Blog</Link></li>
              <li><Link to="/share-story" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">Share Your Story</Link></li>
              <li><Link to="/news-media" className="body-small text-white/70 hover:text-[#dc2626] transition-colors">References & Reads</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Connect</h4>
            <div className="space-y-3 mb-6">
              <a href="mailto:contact@darktourism-malaysia.com" className="body-small text-white/70 hover:text-[#dc2626] transition-colors flex items-center gap-2">
                <Mail size={18} />
                contact@darktourism-malaysia.com
              </a>
              <a href="https://instagram.com/darktourism.malaysia" target="_blank" rel="noopener noreferrer" className="body-small text-white/70 hover:text-[#dc2626] transition-colors flex items-center gap-2">
                <Instagram size={18} />
                @darktourism.malaysia
              </a>
            </div>
            <a href="https://wa.me/60177975779" target="_blank" rel="noopener noreferrer" className="btn-primary text-sm py-2 px-4" data-testid="footer-whatsapp">
              Get in Touch
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#3a2222] pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="body-small text-[#888680]">
            © {new Date().getFullYear()} Dark Tourism Malaysia. All rights reserved.
          </p>
          <div className="flex flex-col md:flex-row items-center gap-4">
            <p className="body-small text-[#888680] text-center md:text-right">
              Built on academic research and respectful preservation of Malaysia's heritage.
            </p>
            <p className="body-small text-[#888680]">
              Designed by <a href="https://thesilver-tree.com" target="_blank" rel="noopener noreferrer" className="text-[#dc2626] hover:text-[#dc2626]/80 transition-colors">SilverTree Design Studio</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
